import apiBase from "../../../api/axios";

export const getFrasesConfirmacionPlantelService = async (
  plantelId,
  page = 1,
  search = "",
  talento = "",
  pregunta = "",
) => {
  let url = `v1/talentos-plantel/frases-confirmacion/?page=${page}&plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (talento) url += `&talento=${talento}`;
  if (pregunta) url += `&pregunta=${pregunta}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const createMultipleFrasesConfirmacionPlantelService = async (
  payload,
) => {
  const response = await apiBase.post(
    "v1/talentos-plantel/frases-confirmacion/crear-multiples/",
    payload,
  );
  return response.data;
};

export const getFraseConfirmacionPlantelByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/frases-confirmacion/${id}/`,
  );
  return response.data;
};

export const updateFraseConfirmacionPlantelService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-plantel/frases-confirmacion/${id}/`,
    payload,
  );
  return response.data;
};

export const toggleFraseConfirmacionPlantelActiveService = async (id) => {
  const response = await apiBase.patch(
    `v1/talentos-plantel/frases-confirmacion/${id}/toggle-status/`,
  );
  return response.data;
};
